import React from 'react';
import './TrainingOptions.css';
import TrainingPreferences from './TrainingPreferences';

const TrainingOptions = ({ selectedPetForTraining, trainingBookingData, setTrainingBookingData }) => {
  // Helper: switch user intent toward grooming if they tap the button
  function switchToGrooming() {
    if (!setTrainingBookingData) return;
    setTrainingBookingData(function(prev){
      var next = Object.assign({}, prev || {});
      var add = next.additionalServices ? Object.assign({}, next.additionalServices) : {};
      add.grooming = true; // hint for the flow to route them to grooming later
      next.additionalServices = add;
      return next;
    });
  }

  // Pet type detection
  var petName = selectedPetForTraining && selectedPetForTraining.name ? selectedPetForTraining.name : 'Your Cat';
  var petType = selectedPetForTraining && selectedPetForTraining.type ? selectedPetForTraining.type : 'Dog';
  var isCat = petType === 'Cat';

  // If cat, render witty notice and early-return
  if (isCat) {
    return (
      <div>
        <div className="options-container">
          <h2 className="options-header">
            <span style={{ color: '#FFB516' }}>{petName}</span>'s Training
          </h2>

          <div className="cat-training-notice">
            <h3>About Cat</h3>
            <p className="cat-witty-line">
              We don’t train cats — they train us. Free spirits with impeccable boundaries.
            </p>

            <p className="cat-witty-sub">
              Here’s what we happily offer for our feline friends:
            </p>
            <ul className="cat-alternatives">
              <li>Handling &amp; grooming acclimation sessions</li>
              <li>Carrier comfort and vet-visit prep</li>
              <li>Home enrichment tips and setup guidance</li>
            </ul>

            <small className="cat-note">
              Want behavior help for cats?
            </small>
            <small className="cat-note">
              We can recommend trusted feline behavior specialists.
            </small>
          </div>
        </div>
      </div>
    );
  }

  // ----- Dog flow (unchanged) -----
  function handleOptionSelect(question, option) {
    switch (question) {
      case 'trainingType':
        setTrainingBookingData(function(prevData){
          var next = Object.assign({}, prevData || {});
          var to = next.trainingOptions ? Object.assign({}, next.trainingOptions) : {};
          to.selectedTrainingType = option;
          next.trainingOptions = to;
          return next;
        });
        break;
      case 'sessionType':
        setTrainingBookingData(function(prevData){
          var next2 = Object.assign({}, prevData || {});
          var to2 = next2.trainingOptions ? Object.assign({}, next2.trainingOptions) : {};
          to2.selectedSessionType = option;
          next2.trainingOptions = to2;
          return next2;
        });
        break;
      default:
        break;
    }
  }

  var selectedTrainingType = trainingBookingData && trainingBookingData.trainingOptions
    ? trainingBookingData.trainingOptions.selectedTrainingType
    : '';

  var selectedSessionType = trainingBookingData && trainingBookingData.trainingOptions
    ? trainingBookingData.trainingOptions.selectedSessionType
    : '';

  return (
    <div>
      <div className="options-container">
        <h2 className='options-header'>
          <span style={{ color: '#FFB516' }}>{petName}</span>'s Training Instructions
        </h2>

        {/* Training Type */}
        <div className='training-list-style'>
          <div className="option-group">
            <h3>Training Type</h3>
            <div className="options">
              <button
                className={'option-button ' + (selectedTrainingType === 'puppy' ? 'selected-training-type-button' : '')}
                onClick={function(){ handleOptionSelect('trainingType', 'puppy'); }}
                disabled={selectedTrainingType === 'puppy'}
                type="button"
              >
                Puppy Training
              </button>
              <button
                className={'option-button ' + (selectedTrainingType === 'basic' ? 'selected-training-type-button' : '')}
                onClick={function(){ handleOptionSelect('trainingType', 'basic'); }}
                disabled={selectedTrainingType === 'basic'}
                type="button"
              >
                Basic Obedience
              </button>
              <button
                className={'option-button ' + (selectedTrainingType === 'behavior' ? 'selected-training-type-button' : '')}
                onClick={function(){ handleOptionSelect('trainingType', 'behavior'); }}
                disabled={selectedTrainingType === 'behavior'}
                type="button"
              >
                Behavior Modification
              </button>
              <button
                className={'option-button ' + (selectedTrainingType === 'akc' ? 'selected-training-type-button' : '')}
                onClick={function(){ handleOptionSelect('trainingType', 'akc'); }}
                disabled={selectedTrainingType === 'akc'}
                type="button"
              >
                AKC Canine Good Citizen
              </button>
            </div>
          </div>

          <div className='option-group'>
            <TrainingPreferences
              trainingBookingData={trainingBookingData}
              setTrainingBookingData={setTrainingBookingData}
            />
          </div>

          {/* Session Type */}
          <div className="option-group">
            <h3>Session Type</h3>
            <div className="options">
              <button
                className={'option-button ' + (selectedSessionType === 'group' ? 'selected-session-type-button' : '')}
                onClick={function(){ handleOptionSelect('sessionType', 'group'); }}
                disabled={selectedTrainingType === 'behavior' || selectedTrainingType === 'akc'}
                type="button"
              >
                Group Session
              </button>
              <button
                className={'option-button ' + (selectedSessionType === 'private' ? 'selected-session-type-button' : '')}
                onClick={function(){ handleOptionSelect('sessionType', 'private'); }}
                type="button"
              >
                Private Session
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingOptions;
